var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-box__field"},[_c('div',_vm._g({},_vm.triggers),[_vm._t("default")],2),_c('input',{ref:_vm.ref,staticStyle:{"display":"none"},attrs:{"type":"file","name":_vm.name,"accept":_vm.accept ? _vm.accept : false},on:{"change":_vm.addFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }